import React, { useState, useRef } from "react";
import { View, StyleSheet, Image, Animated } from "react-native";
import { images } from "../themes";

interface IImageLoadingProps {}

export const ImageLoading = (props: IImageLoadingProps) => {
  const flipAnim = useRef(new Animated.Value(1)).current;

  React.useEffect(() => {
    animation();
  }, [flipAnim]);

  const animation = () => {
    flipAnim.setValue(1);
    Animated.timing(flipAnim, {
      toValue: -1,
      duration: 500,
      useNativeDriver: true,
    }).start(() => animation());
  };

  return (
    <View style={styles.container}>
      <Animated.Image
        source={images.dashboardIcon}
        style={[styles.imageStyles, { transform: [{ scaleX: flipAnim }] }]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  imageStyles: {
    width: 50,
    height: 50,
    opacity: 0.8,
  },
});
